import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Title } from '@models/title';
import { InsurenetInterfaceService } from '../insurenet-interface/insurenet-interface.service';

@Injectable({ providedIn: 'root' })
export class TitlesService {
    private _titles$: BehaviorSubject<Title[]> = new BehaviorSubject<Title[]>([]);
    public titles$: Observable<Title[]> = this._titles$.asObservable().pipe(
        switchMap((titles) => {
            if (!titles.length) {
                return this.fetch();
            } else {
                return of(titles);
            }
        }),
    );
    public constructor(private insurenetInterface: InsurenetInterfaceService) {}

    public fetch(): Observable<Title[]> {
        return this.insurenetInterface.getTitles().pipe(tap((titles) => this._titles$.next(titles)));
    }

    public get companyTitle(): Title | null {
        return this._titles$.getValue().find((title) => title.id === environment.titleCompanyId) ?? null;
    }

    public get companyTitle$(): Observable<Title | null> {
        return this.titles$.pipe(
            map((titles) => titles.find((title) => title.id === environment.titleCompanyId) ?? null),
        );
    }

    public get naturalPersonTitles$(): Observable<Title[]> {
        return this.titles$.pipe(map((titles) => titles.filter((title) => title.id !== environment.titleCompanyId)));
    }

    public titleFromId(id: number): Title {
        return this._titles$.getValue().find((title) => title.id === id);
    }
}
